import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
interface Bonus {
  title: string;
  text: string;
  imageUrl: string;
}
const BONUSES: Bonus[] = [{
  title: 'Bono 1',
  text: '100 ejercicios express para activar, complementar o cerrar cualquier clase.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/e95Ln43VMAKK8YKXKogmGA/IMG_8502.png'
}, {
  title: 'Bono 2',
  text: '30 clases de emergencia listas para aplicar.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/fH4PM9nbiCgpEkx3oxm316/IMG_8502_(2).png'
}, {
  title: 'Bono 3',
  text: 'Manual completo de cues y correcciones verbales.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/whYTxg8prFMzJ6yubaqmc1/IMG_8502_(3).png'
}, {
  title: 'Bono 4',
  text: 'Evaluaciones, anamnesis y fichas imprimibles.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/mt58Ey3vtqbMyncThNBoHj/IMG_8502_(4).png'
}, {
  title: 'Bono 5',
  text: '20 casos reales completamente resueltos.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/qUtuFRpdLbJgiWnusdRimW/IMG_8502_(1).png'
}];
export function Bonuses() {
  return <section className="w-full bg-beige py-20" data-id="element-12" data-mp="3ddiqiulcjj0x">
      <div className="mx-auto max-w-4xl px-5 sm:px-6" data-id="element-13" data-mp="3r5oxbq2m0dnp">
        <div className="mx-auto max-w-2xl text-center" data-id="element-14" data-mp="3n54zsle4j811">
          <p className="inline-flex items-center gap-2 rounded-full border border-brown-light/25 bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-brown-light" data-id="element-15" data-mp="3n6g5iqr4qpus">
            <span className="h-1.5 w-1.5 rounded-full bg-brown-light" data-id="element-16" data-mp="2uhivfax2nzd4" />
            Material extra
          </p>
          <h2 className="mt-5 font-serif text-4xl font-semibold leading-[1.05] text-brown-dark sm:text-5xl" data-id="element-17" data-mp="38h1rv6gitm9l">
            Bonos exclusivos, gratis por hoy
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-brown-dark/70 sm:text-lg" data-id="element-18" data-mp="npi1u6uclmq0">
            Recursos listos para usar y llevar tus clases un paso más allá.
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-19" data-mp="3cjpoz15zwyp5">
          {BONUSES.map((bonus, index) => <motion.article key={bonus.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.42,
          delay: index % 2 * 0.06
        }} className={`overflow-hidden rounded-2xl border border-brown-light/20 bg-white shadow-sm ${index === BONUSES.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-0.625rem)]' : ''}`} data-id="element-20" data-mp="3hgy9h8em9etk" data-mpi={index}>
              <div className="relative aspect-square overflow-hidden" data-id="element-21" data-mp="32rsczs75y2pd">
                <img src={bonus.imageUrl} alt={`Preview del ${bonus.title}: ${bonus.text}`} className="h-full w-full object-cover" data-id="element-22" data-mp="37kv844rl9k7o" />
                <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-brown-dark/35 to-transparent" aria-hidden="true" data-id="element-23" data-mp="2f2h9w42cbw82" />
                <div className="absolute bottom-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-white/90 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-brown-dark" data-id="element-24" data-mp="22kn5qqxcq61y">
                  <GiftIcon className="h-3.5 w-3.5 text-brown-light" data-id="element-25" data-mp="1tl072cw0becl" />
                  {bonus.title}
                </div>
              </div>
              <div className="p-5" data-id="element-26" data-mp="1omgjk81rlui4">
                <p className="font-serif text-xl font-semibold leading-snug text-brown-dark" data-id="element-27" data-mp="1jup0sjouot2j">
                  {bonus.text}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}